import { isPlatformServer } from '@angular/common';
import { SITE_CONFIG_KEY } from '../tokens/site-config-key.token';
// import * as moment from 'moment';
import * as moment from 'moment-timezone';
import * as i0 from "@angular/core";
import * as i1 from "@angular/platform-browser";
import * as i2 from "@nguniversal/express-engine/tokens";
/** 日誌，只有 console 打印 */
export class LoggerService {
    constructor(platformId, transferState, request, response) {
        this.platformId = platformId;
        this.transferState = transferState;
        this.request = request;
        this.response = response;
        this.isServer = isPlatformServer(this.platformId);
        this.isSSRMode = this.isServer || this.transferState.hasKey(SITE_CONFIG_KEY);
    }
    info(msg, ...optionalParams) {
        if (this.isSSRMode) {
            if (this.isServer) {
                global['nodeLogger']['info'](this.request, this.response, msg, ...optionalParams);
            }
            else {
                console.log(`${moment().tz("Asia/Taipei").format('YYYY/MM/DD HH:mm:ss.SSS')} [${'info'}] ${msg}`, ...optionalParams);
            }
        }
        else {
            console.log(msg, ...optionalParams);
        }
    }
    warn(msg, ...optionalParams) {
        if (this.isSSRMode) {
            if (this.isServer) {
                global['nodeLogger']['warn'](this.request, this.response, msg, ...optionalParams);
            }
            else {
                console.warn(`${moment().tz("Asia/Taipei").format('YYYY/MM/DD HH:mm:ss.SSS')} [${'warn'}] ${msg}`, ...optionalParams);
            }
        }
        else {
            console.warn(msg, ...optionalParams);
        }
    }
    error(msg, ...optionalParams) {
        if (this.isSSRMode) {
            if (this.isServer) {
                global['nodeLogger']['error'](this.request, this.response, msg, ...optionalParams);
            }
            else {
                console.error(`${moment().tz("Asia/Taipei").format('YYYY/MM/DD HH:mm:ss.SSS')} [${'error'}] ${msg}`, ...optionalParams);
            }
        }
        else {
            console.error(msg, ...optionalParams);
        }
    }
}
LoggerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoggerService_Factory() { return new LoggerService(i0.ɵɵinject(i0.PLATFORM_ID), i0.ɵɵinject(i1.TransferState), i0.ɵɵinject(i2.REQUEST, 8), i0.ɵɵinject(i2.RESPONSE, 8)); }, token: LoggerService, providedIn: "root" });
